<template>
	<div class="clue-drawer">
		<drawerHeader v-bind="headerInfo" :logo="logo" v-on="$listeners"></drawerHeader>
		<sky-tabs
			v-model="tabValue"
			:tabList="tabList"
			class="custclass-tab"
			:customClass="false"
		></sky-tabs>
		<div class="component">
			<el-scrollbar style="height: 100%">
				<component
					class="context"
					:is="tabValue"
					:isCollapse="false"
					:tableId="tableId"
					:id="summaryId"
					:type="type"
					:summaryId="summaryId"
					
					:garbageFlag="headerInfo.garbageFlag"
					:followupName="headerInfo.followupName"
					:sourceType="headerInfo.sourceType"
				></component>
<!-- 
				<clueActionItems
					class="bottom"
					:tableId="tableId"
					:id="summaryId"
					v-bind="$attrs"
					@changeName="changeName"
				></clueActionItems> -->
			</el-scrollbar>
		</div>
	</div>
</template>
<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import drawerHeader from '@/components/chat/drawer-header.vue';
import drawerInfo from '@/components/chat/drawer-info.vue';
import clueContactInfo from '@/components/crm/clue/clue-contactInfo.vue'; //联系人列表
// import clueSer from '@/client/services/clue/clueSer.js';
import attrInfo from '@/components/chat/components/attrInfo.vue';
import clueActionItems from '@/components/chat/fold/clue-action-items.vue';
// 我的线索、全部线索
//信息不可编辑 联系人可编辑 ,
// 垃圾线索、都不可编辑
// 操作按钮---这不是垃圾，线索详情
export default {
	props: {
		tableId: {
			type: String, //询盘id
		},
		summaryId: {
			type: String,
		},
		headerInfo: {
			type: Object,
		},
		logo:null
	},
	data() {
		return {
			type: 1, //类型：客户为1
			tabValue: 'attrInfo',
			tabList: [
				{
					label: '归因',
					name: 'attrInfo',
				},
				{
					label: '信息',
					name: 'drawerInfo',
				},
				{
					label: '联系人',
					name: 'clueContactInfo',
				},
			],
		};
	},
	watch: {
		tableId: {
			handler(val) {
				if (val && val != '0') {
					this.tabValue = 'attrInfo';
					// this.getContactList();
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		changeName() {
			this.tabValue = 'clueContactInfo';
			this.$nextTick(() => {
				this.tabValue = 'attrInfo';
			});
		},
		changeGarbageFlag(val) {
			this.garbageFlag = val;
		},
		// async getContactList() {
		// 	//联系人列表
		// 	const resContact = await clueSer.contactList({ summaryId: this.summaryId });
		// 	if (resContact.data) {
		// 		this.$store.dispatch('setContactlist', resContact.data);
		// 	}
		// },
	},
	components: {
		drawerHeader,
		drawerInfo,
		skyTabs,
		clueContactInfo,
		attrInfo,
		clueActionItems,
	},
};
</script>
<style lang="scss" scoped>
.sky-tabs {
	padding: 0px !important;
}
.custclass-tab {
	::v-deep  .el-tabs__header {
		margin: 0px !important;
	}
	::v-deep .el-tabs__item {
		padding-left: 20px !important;
	}
}
.clue-drawer {
	width: 380px;
	height: 100%;
	display: flex;
	flex-direction: column;
	::v-deep .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	::v-deep  .el-tabs {
		.el-tabs__header {
			margin: 0;
		}
		.el-tabs__item {
			padding: 0 10px;
		}
		.el-tabs__active-bar {
			height: 3px;
		}
		.el-tabs__nav-wrap {
			background-color: #fafafa;
			padding: 0 5px;
		}
		.el-tabs__nav-wrap::after {
			height: 1px;
		}
	}
}
.component {
	height: calc(100vh - 370px);

	/* height: calc(100vh - 370px); */
	/* display: flex;
	flex-direction: column;
	.context {
		flex: 1;
	} */
}
</style>
